import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  unit: Yup.string().nullable(),
  weight: Yup.string().nullable(),
  length_right: Yup.string().nullable(),
  length_left: Yup.string().nullable(),
  width_right: Yup.string().nullable(),
  width_left: Yup.string().nullable(),
  height_right: Yup.string().nullable(),
  height_left: Yup.string().nullable(),
  length: Yup.string().nullable(),
  width: Yup.string().nullable(),
  height: Yup.string().nullable(),
  commodity_id: Yup.string().nullable(),
  permit: Yup.boolean(),
  notes: Yup.string().nullable()
});
